import React from "react";

function Spinner() {
  return (
    <div className="mx-auto w-10 h-10 border-4 border-gray-300 border-t-gray-800 rounded-full animate-spin mt-20 " />
  );
}

export default Spinner;
